import _ from "lodash";

export const makeQueryString = (data = {}) => {
  let queryString = _.reduce(
    data,
    (result, value, key) => {
      return result + `${key}=${value}&`;
    },
    ""
  );

  if (_.isEmpty(queryString)) {
    return "";
  }
  return queryString.substr(0, queryString.length - 1);
};



// WEBPACK FOOTER //
// ./src/utils/urls.js